var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter_ic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.199,6.681 L10.268,12.318 L10.268,19.264 L12.929,17.884 L12.929,12.318 L19.008,6.68 L19.008,4.273 L4.199,4.273 L4.199,6.681 Z M9.777,21.843 C8.835,21.843 8.069,21.051 8.069,20.077 L8.069,13.331 L2.56,8.214 C2.197,7.863 2,7.39 2,6.9 L2,3.765 C2,2.792 2.765,2 3.708,2 L19.498,2 C20.44,2 21.207,2.792 21.207,3.765 L21.207,6.9 C21.207,7.389 21.009,7.862 20.663,8.198 L15.129,13.331 L15.129,18.2 C15.129,18.859 14.761,19.477 14.189,19.773 L10.545,21.66 C10.233,21.794 10.002,21.843 9.777,21.843 L9.777,21.843 Z",
    id: "Fill-1",
    fill: "#06C86A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIc);
export default __webpack_public_path__ + "static/media/filter_ic.28e8b01cb4317b086764d7c1f76e1239.svg";
export { ForwardRef as ReactComponent };